import styled from '@emotion/styled'

export const PreviewSkeleton = styled('span')(({ theme }) => ({
  display: 'inline-block',
  width: '100%',
  maxWidth: 100,
  margin: '0 auto',
  height: '1em',
  backgroundColor: 'rgba(0, 0, 0, 0.12)',
  borderRadius: 2,
}))
